import React, { useEffect, useState } from 'react';
import './../../styles/SupportModal.css';
import DOMPurify from 'dompurify';
import { marked } from 'marked';
import getBaseUrl from './../../utils/baseUrl';

function SupportModal({ isOpen, onClose }) {
  const [content, setContent] = useState('');

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.keyCode === 27) onClose();  // Escape key
    };

    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [onClose]);

  // Prevent body scroll when modal is open
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
  }, [isOpen]);

  useEffect(() => {
    if (isOpen) {
      const fetchContent = async () => {
        try {
          const response = await fetch(`${getBaseUrl()}/support/support-contact-info/support-info.md`);
          if (!response.ok) {
            throw new Error(`Failed to fetch support info: ${response.statusText}`);
          }
          const markdownText = await response.text();
          const sanitizedHtml = DOMPurify.sanitize(marked(markdownText));
          setContent(sanitizedHtml);
        } catch (error) {
          setContent('<p>Error loading support information. Please try again later.</p>');
          console.error('Error fetching support information');
        }
      };

      fetchContent();
    }
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="modal-body">
          <button className="close-button" onClick={onClose}>&times;</button>
          <div dangerouslySetInnerHTML={{ __html: content }} />
        </div>
      </div>
    </div>
  );
}

export default SupportModal;
